import { useCallback } from "react";

import type * as Type from "../type";

type Props = {
	serverData: Type.ServerData.ReservationListByCInDateServerData | undefined;
};
type Result = {
	queryData: Type.QueryData.ReservationListQueryData;
};

export const useReservationListByCInDateQueryData = () => {
	/**
	 * QueryData へ変換
	 */
	const onConvertQueryData = useCallback(
		({ serverData }: Props): Result => ({
			queryData: {
				reservationList: serverData?.reservationListByCInDate.reservations ?? [],
			},
		}),
		[],
	);

	return {
		onConvertQueryData,
	};
};
